module.exports = "{% if icon %}\n  {{icon}}\n{% endif %}\n{{label|e}}\n";
